const DisclaimerScreen = () => {

    return(
        <p>Disclaimer Screen</p>
    )

}

export default DisclaimerScreen